import { render, staticRenderFns } from "./RecebimentoArsenal.vue?vue&type=template&id=878d9a20&"
import script from "./RecebimentoArsenal.vue?vue&type=script&lang=js&"
export * from "./RecebimentoArsenal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports